import React from 'react';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mCustomer from 'models/cpm/customer';
// Custom
import { cpmCustomerDataShape } from 'constants/PropTypesShapes';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import ParkingCategoryIdIntegIcon from 'cpmCarparks/assets/parkingCategories/ParkingCategoryIdIntegIcon';
import PropTypes from 'prop-types';

const CustomerDesc = ({ customer, email }) => {
  if (customer) {
    // Permissions
    const {
      pCpm: { parkingCategoryRead },
    } = permissions;

    return (
      <div className="d-flex align-items-center">
        <OnlyWith
          permissions={{
            needed: parkingCategoryRead,
            permissionsOrContext: 'carparkPermissions',
          }}
        >
          <ParkingCategoryIdIntegIcon withTooltip parkingCategoryId={mCustomer.getParkingCategoryId(customer)} />
        </OnlyWith>
        <div className="flex-column">
          <TruncatedTooltipText>{mCustomer.title(customer)}</TruncatedTooltipText>
          {email
            ? (
              <span className="font-weight-normal">
                {customer.email}
              </span>
            ) : null}
        </div>
      </div>
    );
  }
  return null;
};

CustomerDesc.propTypes = {
  customer: cpmCustomerDataShape,
  email: PropTypes.string,
};

CustomerDesc.defaultProps = {
  customer: null,
  email: null,
};

module.exports = CustomerDesc;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/customers/CustomerDesc.js